import Api from '@/services/api';
import {removeEmptyParams} from '@utils';

export default {
  settings(filter) {
    return Api()
      .get('/ota/settings', {params: removeEmptyParams(filter)})
      .then((res) => {
        res.data.forEach((e) => {
          this.formatRes(e);
        });
        return res.data;
      });
  },
  update(settings) {
    return Api()
      .put('/ota/settings', settings)
      .then((res) => {
        res.data.forEach((e) => {
          this.formatRes(e);
        });
        return res.data;
      });
  },
  formatRes(e) {
    return e;
  },
};
